/**
 * nav.js — the Амбстат sections as the CRM sidebar lists them (AV2-4k §3.2): the ONE list of section
 * ids and titles, the last-used section, and a tiny badge store the shell publishes into.
 * It imports `react` only: the sidebar is eager and the tab is lazy, so nothing here may reach
 * `sections.js` or a section component (`AV2-SCOPE-4K`'s `eager` limb).
 */
import { useSyncExternalStore } from 'react';

export const AMB_NAV = [
  { id: 'overview', title: 'Обзор' }, { id: 'views', title: 'Просмотры' },
  { id: 'ambassadors', title: 'Амбассадоры' }, { id: 'videos', title: 'Ролики' }, { id: 'team', title: 'Команда' },
  { id: 'journal', title: 'Журнал' },
];

const KEY = 'ambstat.section';
/** The last-used section (per browser, like `ambstat.tz`), `overview` when none or unknown. */
export function readSection () {
  try { const v = localStorage.getItem(KEY); return AMB_NAV.some((s) => s.id === v) ? v : 'overview'; } catch { return 'overview'; }
}
export function writeSection (id) { try { localStorage.setItem(KEY, id); } catch { /* refused: the default wins next time */ } }

/** `{ [sectionId]: count }` — live only while /ambstat is mounted (the shell clears it on unmount). */
let badges = {};
const subs = new Set();
const subscribe = (fn) => { subs.add(fn); return () => subs.delete(fn); };
export function setNavBadges (map) { badges = map; subs.forEach((fn) => fn()); }
export const useNavBadges = () => useSyncExternalStore(subscribe, () => badges);
